import { ApiCatch, Catch } from "@/utils/decorators";
import { PlanDetailSaveDTO } from "~/plan.detail.save.dto";
import { PlanDetailsDTO } from "~/plan.details.dto";
import { PlanStatusChangeDTO } from "~/plan.status.change.dto";
import { PlansDto } from "~/plans.dto";
import { SavePlanDTO } from "~/save.plan.dto";
import { SaveSignDTO } from "~/save.sign.dto";
import { Api } from "../api.service";

export class ChangePlanService {
  @ApiCatch
  static async getStatuses() {
    const response = await Api.get("/change-plan/get-statuses");
    return response.data;
  }
  @Catch(() => [])
  static async getChangePlan(req: PlansDto) {
    const response = await Api.get("/change-plan/", {
      params: { ...req },
    });
    return response.data;
  }
  @Catch(() => [])
  static async getRequestChangePlan(req: PlanDetailsDTO) {
    const response = await Api.get("/change-plan/get-details", {
      params: { ...req },
    });
    return response.data;
  }
  @Catch(() => [])
  static async savePlan(req: PlanDetailSaveDTO) {
    const response = await Api.post("/change-plan/save", req);
    return response.data.result;
  }
  @Catch(() => [])
  static async statusChangePlan(req: PlanStatusChangeDTO) {
    const response = await Api.post("/change-plan/status-change", req);
    return response.data;
  }
  @Catch(() => [])
  static async saveSign(req: SaveSignDTO) {
    const response = await Api.post("/change-plan/save-sign", req);
    return response.data;
  }
  @Catch(() => [])
  static async saveCCPlan(req: SavePlanDTO) {
    const response = await Api.post("/change-plan/save-plan", req);
    return response.data;
  }
  @Catch(() => [])
  static async checkExistsChangePlan(iContractRid: number) {
    const response = await Api.get("/change-plan/checkExistsChangePlan", {
      params: { iContractRid: iContractRid },
    });
    return response.data;
  }
  @Catch(() => [])
  static async getCurrentChangePlanDoc(iContractRid: number) {
    const response = await Api.get("/change-plan/getCurrentChangePlanDoc", {
      params: { iContractRid: iContractRid },
    });
    return response.data;
  }
}
